export const GET_DATA_FROM_SOURCE = "GET_DATA_FROM_SOURCE";
export const SET_DATA_FROM_SOURCE = "SET_DATA_FROM_SOURCE";
